export class ApiUrl{
    public static url : string ="https://nbsapi.novatel.com.tr:444/api/";
    //public static url : string ="https://localhost:44317/api/";
}